import React from 'react'

import Compare from 'components/CommonComparisons/components/Compare'
import CtaButton from 'components/CtaButton'
import Grid from 'components/Grid'
import Link from 'components/Link'
import { useEventContext } from 'context/EventContext'
import { revealSEOUrl } from 'helpers/SEOHelper'

import classes from './PopularComparisons.module.scss'

const getRelativePath = url => {
  if (!url) return url
  try {
    const urlObj = new URL(url, 'https://dummy.com')
    return urlObj.pathname + urlObj.search + urlObj.hash
  } catch {
    return url // Already relative or invalid
  }
}

/** @type {import("./types").default} */
const PopularComparisons = ({ listing, gridProps }) => {
  const eventContext = useEventContext({
    engagementComponent: 'product_comparisons',
  })

  return (
    <Grid spacing={2} container>
      {listing.popular_comparisons.map(compare => (
        <Grid
          {...eventContext.addEvent({
            name: 'engagement_cta_compare',
            engagementDetails: 'card_product-vs-product',
            engagementDestination: 'go-to_compare',
            compareProductUuids: `${listing.global_product_id}, ${compare.global_product_id}`,
          })}
          component={Link}
          disableSeo={!compare.compare_page.is_seo}
          href={getRelativePath(revealSEOUrl(compare.compare_page.url))}
          className={classes.link}
          item
          xs={12}
          sm={6}
          lg={4}
          key={compare.id}
          {...gridProps}
        >
          <Compare className={classes.item} listings={[listing, compare]} />
        </Grid>
      ))}
      {listing.cta_urls.alternatives && (
        <Grid xs={12} item className={classes.alternatives}>
          <CtaButton
            href={listing.cta_urls.alternatives}
            {...eventContext.addEvent({
              engagementDestination: 'go-to_alternatives',
              engagementDetails: 'button_browse-alternatives',
              name: 'engagement_product_click',
            })}
            self
            variant="outlined"
          >
            Browse alternatives
          </CtaButton>
        </Grid>
      )}
    </Grid>
  )
}

export default PopularComparisons
